module.exports = __webpack_public_path__ + "sansg/img/13.6ffc63a3.png";